<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pviii"></a><a class="page" id="pix"></a>contents</h1>
<p class="tocf"><a class="xref" href="#/rbgfeder0009#intro" id="rintro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/rbgfeder0010#ch01" id="rch01">Chapter 1</a></p>
<p class="toc"><a class="xref" href="#/rbgfeder0011#ch02" id="rch02">Chapter 2</a></p>
<p class="toc"><span class="xref" href="#/rbgfeder0012#ch03" id="rch03" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0013#ch04" id="rch04" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0014#ch05" id="rch05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0015#ch06" id="rch06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0016#ch07" id="rch07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0017#ch08" id="rch08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0018#ch09" id="rch09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0019#ch10" id="rch10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0020#ch11" id="rch11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0021#ch12" id="rch12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0022#ch13" id="rch13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0023#ch14" id="rch14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0024#ch15" id="rch15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0025#ch16" id="rch16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0026#ch17" id="rch17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0027#ch18" id="rch18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0028#ch19" id="rch19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0029#ch20" id="rch20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0030#ch21" id="rch21" title="Link target outside of Sample">Chapter 21</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0031#ch22" id="rch22" title="Link target outside of Sample">Chapter 22</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0032#ch23" id="rch23" title="Link target outside of Sample">Chapter 23</span></p>
<p class="toc"><span class="xref" href="#/rbgfeder0033#ch24" id="rch24" title="Link target outside of Sample">Chapter 24</span></p>
<p class="tocbmf"><span class="xref" href="#/rbgfeder0034#acknow" id="racknow" title="Link target outside of Sample">Acknowledgments</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// rbgfeder0008.vue?7d981635